var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightprimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0866 9.00998C12.0866 9.25123 11.9977 9.49246 11.8203 9.6764L6.23547 15.4646C5.8802 15.8328 5.3042 15.8328 4.94908 15.4646C4.59396 15.0965 4.59396 14.4997 4.94908 14.1314L9.89086 9.00998L4.94925 3.8885C4.59413 3.52029 4.59413 2.9235 4.94925 2.55547C5.30437 2.18709 5.88038 2.18709 6.23564 2.55547L11.8205 8.34355C11.9979 8.52758 12.0866 8.76881 12.0866 9.00998Z",
    fill: "#6A4FF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightprimary);
export default __webpack_public_path__ + "static/media/arrow-right.primary.a4a58ec9dae65e9f041d2d8d5983056a.svg";
export { ForwardRef as ReactComponent };